export const LoggerTypes = {
  AZURE: 'AZURE',
  WARN: 'WARN',
  DEFAULT: 'DEFAULT',
  INIT: 'INIT',
  CONTAINER: 'CONTAINER',
  CONTROLLER: 'CONTROLLER',
  ACTION: 'ACTION',
  REDUCER: 'REDUCER',
  API: 'API',
  BPMN: 'BPMN',
  BPMN_EVENT: 'BPMN_EVENT',
  DEBUG: 'DEBUG',
  ACCESS_CONTROL: 'ACCESS_CONTROL'
}

const traceColors = {
  [LoggerTypes.AZURE]: { background: '#6EF', text: '#000' },
  [LoggerTypes.WARN]: { background: '#F00', text: '#000' },
  [LoggerTypes.DEFAULT]: { background: '#FFF', text: '#333' },
  [LoggerTypes.INIT]: { background: '#570', text: '#FFF' },
  [LoggerTypes.PAGE]: { background: '#02E', text: '#FFF' },
  [LoggerTypes.CONTAINER]: { background: '#0AF', text: '#333' },
  [LoggerTypes.CONTROLLER]: { background: '#0EA', text: '#333' },
  [LoggerTypes.ACTION]: { background: '#0E0', text: '#333' },
  [LoggerTypes.REDUCER]: { background: '#FE0', text: '#333' },
  [LoggerTypes.API]: { background: '#F60', text: '#333' },
  [LoggerTypes.BPMN]: { background: '#84F', text: '#FFF' },
  [LoggerTypes.BPMN_EVENT]: { background: '#A0E', text: '#FFF' },
  [LoggerTypes.ACCESS_CONTROL]: { background: '#C09', text: '#FFF' },
  [LoggerTypes.DEBUG]: { background: '#C09', text: '#000' }
}

export class Logger {
  static trace(type, classMethod, obj) {
    if (process.env.NODE_ENV !== 'production') {
      const color = traceColors[type] || traceColors.DEFAULT
      console[type === LoggerTypes.WARN ? 'warn' : 'log'](
        `%c${classMethod}`,
        `background: ${color.background}; color: ${color.text}; margin: 0; padding: 1px 3px; border-radius: 3px`,
        obj
      )
    }
  }
}
